// Babel Polyfill provides a number of useful polyfills for converting ES6 syntax to
// IE friendly
import "babel-polyfill";

// The fetch polyfill could be refactored out if all SVGs are loaded from the
// asset store, but should be left in to catch instances where assets are not
// loaded from the asset store.
import 'whatwg-fetch';

// Array.protptype.find polyfill.
// https://gist.github.com/markhowellsmead/7fa5ad4a7d2eb6245cae13942da78b6a
// If this still isn't working, you can mimic the functinoality of find()
// by using filter() and selecting the 0 index in the returned array.
if (!Array.prototype.find) {
	// eslint-disable-next-line no-extend-native
	Array.prototype.find = function find(predicate, ...args) {
		if (this == null) {
			throw new TypeError('Array.prototype.find called on null or undefined');
		}

		if (typeof predicate !== 'function') {
			throw new TypeError('predicate must be a function');
		}

		const list = Object(this);
		// eslint-disable-next-line no-bitwise
		const length = list.length >>> 0;
		const thisArg = args[1];
		let value;

		for (let i = 0; i < length; i += 1) {
			value = list[i];

			if (predicate.call(thisArg, value, i, list)) {
				return value;
			}
		}

		return undefined;
	};
}



// WEBPACK FOOTER //
// ./src/lib/ie11-polyfills.js